<app-header></app-header>
<app-botao-chat></app-botao-chat>


<div class="container py-4">
  <div class="row">
    <div class="col-12">

      @if (alertSucesso === true) {
        <div class="body-senha">
          <div class="div-alert text-center">
            <img class="mt-4" src="/assets/img/success.png" alt="Sucesso" width="82px">
            <p class="titulo-alert mt-4"> {{ alertSucessoSubtitulo }} </p>
            <div class="footer-alert">
              <p class="subtitulo-alert"> {{ alertSucessoMensagem }} </p>
              <button class="botao-secundario-outline mt-3"
              (click)="fecharAlertSucesso()">SAIR</button>
            </div>
          </div>
        </div>
      }

      @if (erroSenha === true) {
        <div class="body-senha">
          <div class="div-alert text-center">
            <img class="mt-4" src="/assets/img/error.png" alt="Erro" width="82px">
            <p class="titulo-alert mt-4 c-danger"> {{ alertErroSubtitulo }}
            </p>
            <div class="footer-alert bg-danger">
              <p class="subtitulo-alert"> {{ alertErroMensagem }} </p>
              <button class="btn-borda-branca btn-font-branco btn-grande-vermelho mt-3"
              (click)="fecharAlertErro()">SAIR</button>
            </div>
          </div>
        </div>
      }
      <div class="card">
        <div class="row">
          <div class="col">
            <app-breadcrumb></app-breadcrumb>
            <h1 class="titulo">Gerenciar permissões</h1>
          </div>
          <div class="col d-inline-block align-right">
            <i
              class="fa fa-arrow-left float-end me-1 botao-setinha-voltar"
              routerLink="/editar-contato/"
              aria-hidden="true">
            </i>

            <i
              class="fa fa-info-circle c-black icone-padrao float-end me-1"
              aria-hidden="true"
              [popover]="statusAcessoPortal"
              popoverTitle="Status de acesso ao portal"
              popoverPlacement="bottom"
              triggers="click"
              [outsideClick]="true">
            </i>

            <ng-template #statusAcessoPortal>
              <span class="texto-tabela legenda">
                Libera o contato para acessar o portal de gestão de vale transporte utilizando o ID ou senha definidos.
              </span>
            </ng-template>

            <p class="float-end me-1">Status de acesso</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>Gerencie todos os acessos do portal para esse contato</p>
          </div>
          <div class="col align-right btn-toggle">
            <mat-slide-toggle  class="mat-mdc-slide-toggle mat-accent" #slide [(ngModel)]="enabled" (change)="toggleUser($event)">
              <span>{{slide.checked?'Ativado':'Desativado'}}</span>
            </mat-slide-toggle>
          </div>
        </div>

        @if (erro === true) {
          <div class="text-center">
            <img src="/assets/img/erro.png" alt="Erro na pagina" width="200px">
            <p class="legenda-erro">Ocorreu um erro na consulta da pagina gerenciar permissões.</p>
          </div>
        }

        @if (erro === false) {
          <div class="row mt-3">
            <div class="col">
              <p><strong>Nome:</strong> {{resource?.nomeContato}}</p>
            </div>
          </div>
        }

        <div [ngClass]="slide.checked ? '' : 'lock-contents'">

          <div class="mt-3">
            <!-- NAVEGAÇÃO DAS ABAS DO DETALHAMENTO DO PEDIDO -->
            <ul class="nav nav-tabs border-0 mt-4 mb-4" id="myTab">
              <li class="nav-item">
                <a class="nav-link active ps-0"
                  id="enderecosTab"
                  data-bs-toggle="tab"
                  href="#enderecos"
                  aria-controls="enderecos">
                  Endereços
                </a>
              </li>
              <li class="nav-item">

                @if (abaEnderecos?.selectedAddress.length == 0 || selectedAddressParent?.length == 0) {
                  <a
                    class="nav-link disabled"
                    aria-disabled="true"
                    tabindex="-1">
                    Permissões
                  </a>
                }

                @if (abaEnderecos?.selectedAddress.length > 0 && selectedAddressParent?.length > 0) {
                  <a
                    class="nav-link"
                    #permissoesTab
                    id="permissoesTab"
                    data-bs-toggle="tab"
                    href="#permissoes"
                    aria-controls="permissoes">
                    Permissões
                  </a>
                }

              </li>
            </ul>

            <!-- Conteúdo das TABS (navegação entre as abas) -->
            <div class="tab-content" id="myTabContent">
              <!-- Endereços -->
              <div class="tab-pane fade show active" id="enderecos" role="tabpanel"
                aria-labelledby="historicoTab">
                <div class="col-12">
                  <app-gerenciar-permissoes-enderecos [idContato]="idContato"
                    (salvarEventEmitter)="permissoesFoward($event)"
                    #abaEnderecos>
                  </app-gerenciar-permissoes-enderecos>
                </div>
              </div>
              <!-- Permissoes -->
              <div class="tab-pane fade" id="permissoes" role="tabpanel"
                aria-labelledby="ocorrenciasTab">
                <div class="col-12">
                  <app-gerenciar-permissoes-permissoes [idContato]="idContato"
                    [selectedAddressChild]="selectedAddressParent">
                  </app-gerenciar-permissoes-permissoes>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
